<div class="notification-container" #dropdownElement>
  <!-- Notification Bell Button -->
  <button
    class="notification-bell btn"
    [class.has-notifications]="hasUnread()"
    (click)="toggleDropdown()"
    type="button"
    aria-label="Notifications">
    <i class="bi bi-bell"></i>
    <span
      class="notification-badge"
      [class.d-none]="!hasUnread()"
      [attr.aria-label]="unreadCount() + ' unread notifications'">
      {{ unreadCount() > 99 ? '99+' : unreadCount() }}
    </span>
  </button>

  <!-- Dropdown Menu -->
  <div
    class="notification-dropdown"
    [class.show]="isOpen()"
    [attr.aria-hidden]="!isOpen()">

    <!-- Header -->
    <div class="notification-header d-flex justify-content-between align-items-center">
      <h6 class="mb-0">Bildirimler</h6>
      <button
        class="btn mark-all-read"
        [class.d-none]="!hasUnread()"
        (click)="markAllAsRead()"
        type="button">
        <i class="bi bi-check-all"></i>
        Tümünü okundu işaretle
      </button>
    </div>

    <!-- Notification List -->
    <div
      class="notification-list"
      *ngIf="notifications().length > 0; else emptyState">

      <div
        *ngFor="let notification of notifications(); trackBy: trackByNotificationId"
        class="notification-item"
        [class.unread]="!notification.read"
        [class.read]="notification.read"
        [class.removing]="isRemoving(notification.id)"
        [class.marking-read]="false"
        [attr.data-notification-id]="notification.id"
        (click)="markAsRead(notification, $event)">

        <div class="d-flex">
          <!-- Notification Icon -->
          <div class="notification-icon" [class]="getNotificationColor(notification.type)">
            <i class="bi" [class]="getNotificationIcon(notification.type) + ' text-white'"></i>
          </div>

          <!-- Notification Content -->
          <div class="notification-content flex-grow-1">
            <div class="notification-title">{{ notification.title }}</div>
            <div class="notification-text">{{ notification.message }}</div>
            <div class="notification-time" *ngIf="notification.time">{{ notification.time }}</div>

            <!-- Action Buttons -->
            <div
              class="notification-actions mt-2"
              *ngIf="notification.actionable && notification.actions?.length">
              <button
                *ngFor="let action of notification.actions"
                class="btn btn-sm me-2"
                [class]="'btn-' + (action.type || 'secondary')"
                (click)="executeAction(action, $event)">
                {{ action.label }}
              </button>
            </div>
          </div>
        </div>

        <!-- Remove Button -->
        <button
          class="remove-notification btn"
          (click)="removeNotification(notification.id, $event)"
          type="button"
          [attr.aria-label]="'Remove notification: ' + notification.title">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>

    <!-- Empty State -->
    <ng-template #emptyState>
      <div class="empty-notifications text-center">
        <i class="bi bi-bell-slash"></i>
        <div>Yeni bildirim yok</div>
        <small class="text-muted">Hepsi okundu!</small>
      </div>
    </ng-template>

    <!-- Demo Controls (Remove in production) -->
    <div class="demo-controls border-top p-3" *ngIf="false">
      <div class="d-flex gap-2 flex-wrap">
        <button class="btn btn-sm btn-outline-primary" (click)="addDemoNotification()">
          Add Demo
        </button>
        <button class="btn btn-sm btn-outline-warning" (click)="addProfileNotification()">
          Add Profile
        </button>
      </div>
    </div>
  </div>

  <!-- Backdrop -->
  <div
    class="notification-backdrop"
    *ngIf="isOpen()"
    (click)="closeDropdown()">
  </div>
</div>